import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
import { useAuth } from '../provider/authProvider';
import { ProtectedRoute } from './protectedRoutes';
import { AdminRoute } from './admin_routes';
import LoginPage from '../pages/Login';
import DashboardPage from '../pages/DashboardPage';
import RegisterPage from '../pages/Register';
import ManualOrderClose from '../pages/ManualOrderClose';
import LandingPage from '../pages/LandingPage';
import AdminMainPage from '../pages/Admin/admin_main_page';

const AppRoutes = ()=>{
    const {token} = useAuth();
    
    // Debug logging
    
    return (
        <BrowserRouter>
            <Routes>
                {!token ? (
                    // Public routes for unauthenticated users
                    <>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/register" element={<RegisterPage />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </>
                ) : (
                    // Protected routes for authenticated users
                    <>
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="/dashboard" element={
                            <ProtectedRoute>
                                <DashboardPage />
                            </ProtectedRoute>
                        } />
                        <Route path="/logout" element={
                            <ProtectedRoute>
                                <></>
                            </ProtectedRoute>
                        } />
                        <Route path="/adminPanel" element={
                            <AdminRoute>
                                <AdminMainPage />
                            </AdminRoute>
                        } />
                        <Route path="/manual-close" element={
                            <ProtectedRoute>
                                <ManualOrderClose />
                            </ProtectedRoute>
                        } />
                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </>
                )}
            </Routes>
        </BrowserRouter>
    );
}

export default AppRoutes;